module.exports = __webpack_public_path__ + "11dbdea1a2d215ebf7c71d963d4b541c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/squinty-18.png
// module id = 2190
// module chunks = 0